import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Grid, Button } from '@material-ui/core';
import {
    NavigateNext as NavigateNextIcon,
    NavigateBefore as NavigateBeforeIcon,
} from '@material-ui/icons';
import Translator from '%app/js/common/services/translator';
import LocalizationStorage from '%app/js/common/services/localizationStorage';

const SubmissionBlock = ({ classes: { root }, submitStep }) => (
    <Grid className={root} justify="flex-end" container>
        <Grid xs={12} sm={6} md={4} item>
            <Button
                color="primary"
                variant="contained"
                size="large"
                onClick={submitStep}
                endIcon={LocalizationStorage.isCurrentLanguageRtl() ? <NavigateBeforeIcon /> : <NavigateNextIcon />}
                fullWidth
            >
                {Translator.trans('paysera_seat_selection_integration.checkout.submit_button')}
            </Button>
        </Grid>
    </Grid>
);

SubmissionBlock.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.string.isRequired,
    }).isRequired,
    submitStep: PropTypes.func.isRequired,
};

export default memo(SubmissionBlock);
